import React from "react";
import { 
    Level, LevelItem, Grid, GridItem, ClipboardCopy, List, ListItem
} from '@patternfly/react-core';
import NetworkIcon from '@patternfly/react-icons/dist/esm/icons/network-icon';

const NetworkInfo = ({
  vm
}) => {
  return (
    <>
    <Grid
      hasGutter
      span={12} 
      style={{
          fontSize: "12px",
          lineHeight: "1.6"
      }}
    >
      <>
      <GridItem span={12}>
        <Level>
          <LevelItem><NetworkIcon style={{marginRight: '5px'}}/> <b>Karty Sieciowe:</b></LevelItem>
          <LevelItem>
          </LevelItem>
        </Level>
        {vm?.nics.map((nic) => (
          <React.Fragment key={nic.id || nic.name}>
          <List style={{listStyleType: 'none'}}>
            <ListItem style={{listStyleType: 'none', margin: "0px"}}>
              <b>{nic.name}</b> {nic?.reporteddevices_data?.reported_device?.length > 0 && (
                nic.reporteddevices_data.reported_device.map((device) => (
                    vm.status === "up" && ` (${device.name})`
                ))
              )}
              <List style={{listStyleType: 'none', paddingTop: "0px"}}>
                <ListItem>
                  <Level>
                    <LevelItem>IP Address:</LevelItem>
                    <LevelItem>
                      {nic?.reporteddevices_data?.reported_device?.length > 0 && vm.status === "up" ? (
                        nic.reporteddevices_data.reported_device.map((device) => (
                          <span key={device.id}>
                            <ClipboardCopy 
                              copyAriaLabel="Copy inline compact example"
                              hoverTip="Kopiuj"
                              clickTip="Skopiowano"
                              variant="inline-compact"
                              style={{marginRight: "0px", paddingRight: "0px"}}
                            >
                          {device.ips?.ip
                            ?.filter((ip) => ip.version === "v4")
                            .map((ip) => ip.address)
                            .join(", ")}
                            </ClipboardCopy>
                        </span>
                      ))
                      ) : (
                        "N/A"
                      )}
                    </LevelItem>
                  </Level>
                  <Level>
                    <LevelItem>MAC:</LevelItem>
                    <LevelItem>
                      <ClipboardCopy 
                        copyAriaLabel="Copy inline compact example"
                        hoverTip="Kopiuj"
                        clickTip="Skopiowano"
                        variant="inline-compact"
                        style={{marginRight: "0px", paddingRight: "0px"}}
                      >
                        {nic.mac.address}
                      </ClipboardCopy>
                    </LevelItem>
                  </Level>
                </ListItem>
              </List>
            </ListItem>
          </List>
          </React.Fragment>
        ))}
      </GridItem>
      </>
    </Grid>
    </>
  );
};

export default NetworkInfo;